import { Injectable, ViewContainerRef } from "@angular/core";
import { DwdmDiagramAbstractConverterIntermediates } from "../../diagram/converter/dwdm-diagram-abstract-converter-intermediates";
import {
    IntermediatesConverterData,
    IntermediateElementIdentifier
} from "../../diagram/converter/dwdm-diagram-converter.models";
import { DwdmCircuitDiagnosticData } from "../../dwdm-circuit.model";
import { DwdmDiagramDiagnosticConverterAmplifiersService } from "./dwdm-diagram-diagnostic-converter-amplifiers.service";
import { DwdmDiagramDiagnosticConverterOscsService } from "./dwdm-diagram-diagnostic-converter-oscs.service";

/**
 * Responsável por converter @see IntermediatesConverterData em @see IntermediateDeviceElement.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramDiagnosticConverterIntermediatesService extends DwdmDiagramAbstractConverterIntermediates {

    constructor(private readonly amplifiersConverterService: DwdmDiagramDiagnosticConverterAmplifiersService,
            private readonly oscsConverterService: DwdmDiagramDiagnosticConverterOscsService) {
        super();
    }

    public convert(intermediatesData: IntermediatesConverterData, diagnosticData: DwdmCircuitDiagnosticData,
            diagnosticModalViewRef: ViewContainerRef): IntermediateElementIdentifier[] {

        return this.convertData(intermediatesData, {
            amplifiers: (data) => this.amplifiersConverterService.convert(data, diagnosticData, diagnosticModalViewRef),
            oscs: (data) => this.oscsConverterService.convertForIntermediate(data, diagnosticData, diagnosticModalViewRef)
        });
    }
}
